export const LOADING = 'LOADING'

export const SET_TOKEN = 'SET_TOKEN'

export const API_REQUEST = 'API_REQUEST'
export const API_SUCCESS = 'API_SUCCESS'
export const API_FAILURE = 'API_FAILURE'
